export enum FaseTratamentoEnum {
    PREVENTIVA = 'P',
    INTERCEPTATIVA = 'I',
    CORRETIVA = 'C',
    ORTOPEDICA = 'O'
}


// WEBPACK FOOTER //
// ./src/app/components/base/enum/fase-tratamento.ts